export default {
	trackByISRC: (isrc: string) => `/track/${isrc}`,
	topPlaylists: (isrc: string) => `/tracks/${isrc}/top-playlists`,
};
